import { Component, Input, OnInit } from '@angular/core';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import { ProformsSubmissionService } from '../../../services/proforms/proforms-submission.service';
import { CreateProformSubmissionPayload } from '../../../types/payloads/proforms.payloads';
import {
  ProFormsQuestionAPIResponse,
  ProFormsSubmissionAPIResponse,
} from '../../../types/responses/proforms.responses';
import { RubricFieldTypeSpecs } from '../proforms-admin/proforms-admin-question-answer-rubric/proforms-admin-question-answer-rubric.component';

@Component({
  selector: 'app-proforms-question-answer-rubric',
  standalone: false,
  templateUrl: './proforms-question-answer-rubric.component.html',
  styleUrl: './proforms-question-answer-rubric.component.scss',
})
export class ProformsQuestionAnswerRubricComponent implements OnInit {
  @Input() question: ProFormsQuestionAPIResponse;

  @Input() viewState: ProformViewStates;

  fieldTypeSpecs: RubricFieldTypeSpecs;

  viewStates = ProformViewStates;

  chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  constructor(private proformsSubmissionService: ProformsSubmissionService) {}

  ngOnInit(): void {
    if (this.question) {
      this.fieldTypeSpecs = JSON.parse(this.question.field_type_specs);
      if (
        this.viewState === this.viewStates.SUBMITTED ||
        this.viewState === this.viewStates.GRADED
      ) {
        this.proformsSubmissionService.currentSubmission.subscribe(
          (submission) => {
            setTimeout(() => {
              this.setAnswersFromSubmission(submission);
            }, 100);
          }
        );
      } else if (this.viewState === this.viewStates.EDIT) {
        this.proformsSubmissionService.newSubmission.subscribe((submission) => {
          setTimeout(() => {
            this.setAnswersFromSubmission(submission);
          }, 100);
        });
      }
    }
  }

  get isInputInteractive(): boolean {
    return this.viewState === this.viewStates.EDIT;
  }

  setAnswersFromSubmission(
    submission:
      | CreateProformSubmissionPayload
      | ProFormsSubmissionAPIResponse
      | null
  ): void {
    if (!submission?.answers) return;

    // FIND RELEVANT ANSWERS
    const currentQuestionsAnswers = submission.answers.filter(
      (a) => a.proform_form_question_id === this.question.id
    );

    // IF OPTION EXISTS, APPLY THE "SELECTED" CLASS
    currentQuestionsAnswers.forEach((answer) => {
      const option = this.question.answerOptions.find(
        (currentOption) =>
          currentOption.id === answer.proform_form_question_answer_option_id
      );
      if (option && answer.selectedCell) {
        const ci = answer.selectedCell.split(':')[0];
        const giLevel = parseInt(answer.selectedCell.split(':')[1], 10) + 1;
        const target = document.getElementById(
          `${this.question.id}_comp_${ci}_lvl_${giLevel}`
        ) as HTMLInputElement;
        target.classList.add('selected');
      }
    });
  }

  selectLevel(ci: number, gi_level: number, event: Event) {
    if (this.viewState !== this.viewStates.EDIT) return;

    // REMOVE AND RE-APPLY "SELECTED" CLASS
    const allLevelItems = document.querySelectorAll('.level-item');
    allLevelItems.forEach((item) => {
      if (item.classList.contains(`${this.question.id}_comp_${ci}`)) {
        item.classList.remove('selected');
      }
    });
    const input = event.target as HTMLInputElement;
    input.parentElement?.classList.add('selected');

    // FIND MATCHING OPTION
    const optionAnswer = `${this.chars[ci]}:${gi_level}`;
    const option = this.question.answerOptions.find(
      (answerOption) => optionAnswer === answerOption.answer
    );

    // FIND EXISTING OPTIONS FOR COMPETENCY AND REMOVE FROM PAYLOAD
    const otherOptions = this.question.answerOptions.filter(
      (answerOption) => answerOption.answer.split(':')[0] === this.chars[ci]
    );
    otherOptions.forEach((otherOption) => {
      this.proformsSubmissionService.removeAnswerFromPayload(otherOption.id);
    });

    // UPDATE SERVICE
    if (option) {
      this.proformsSubmissionService.addAnswerToPayload(
        {
          proform_form_question_id: this.question.id,
          proform_form_question_answer_option_id: option?.id,
        },
        this.question.field_type
      );
    }
  }
}
